import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../styles.css";

const API_BASE = "https://css-67zw.onrender.com";

export default function Home() {
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    axios.get(`${API_BASE}/api/mcqs`)
      .then(res => {
        const uniqueSubjects = [
          ...new Set(res.data.map(q => q.subject))
        ];
        setSubjects(uniqueSubjects);
      })
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="home-container">
      <h1 className="title">CSS / PMS MCQ Prep</h1>
      <p className="subtitle">Select a subject to start practicing</p>

      <div className="card-grid">
        {subjects.map((sub, index) => (
          <Link
            key={index}
            to={`/browse/${encodeURIComponent(sub)}`}
            className="subject-card"
          >
            <h3>{sub}</h3>
            <p>Start Practice →</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
